import React, { useEffect, useState } from 'react';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const trigger = document.getElementById('problem-solution');
      if (trigger) {
        const rect = trigger.getBoundingClientRect();
        setVisible(rect.top <= window.innerHeight * 0.8);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToForm = () => {
    const form = document.getElementById('register-form');
    if (form) {
      form.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <div className={`fixed bottom-0 left-0 right-0 z-50 sm:hidden transition-all duration-300 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0 pointer-events-none'}`} data-id="element-142">
      <div className="bg-white/95 backdrop-blur-md border-t border-gray-200 px-4 py-3 shadow-[0_-4px_20px_-4px_rgba(0,0,0,0.1)]" data-id="element-143">
        <button onClick={scrollToForm} className="w-full py-3.5 text-base font-bold text-white bg-brand-coral hover:bg-brand-coralHover rounded-full shadow-[0_4px_12px_-2px_rgba(232,97,74,0.4)] active:scale-[0.98] transition-all duration-200" data-id="element-144">
          Ja, ik meld me gratis aan!
        </button>
      </div>
    </div>;
}